<template>
    <router-view />
</template>

<script>
export default {
    name: "IntegrationsIndex"
}
</script>
